'use client';

import {
  CircularProgress,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { stickNameCell, StyledHeaderTableCell, StyledTable } from '~/shared';
import { CampaignProductDailyReport } from '~/types';

import { useGetSponsoredProductsReportsProduct } from '../../hooks';

import { SponsoredProductsReportsBannerRow } from './Row';

export type SponsoredProductsReportsBannerListProps = {
  getReportsBannerQuery: ReturnType<
    typeof useGetSponsoredProductsReportsProduct
  >;
};

export function SponsoredProductsReportsBannerList({
  getReportsBannerQuery,
}: SponsoredProductsReportsBannerListProps) {
  const { data, isLoading, isError, error } = getReportsBannerQuery;

  return (
    <StyledTable aria-label="Tabela de Relatórios Diários de Banner de Produtos Patrocinados">
      <TableHead>
        <TableRow>
          <StyledHeaderTableCell sx={stickNameCell()}>
            Data
          </StyledHeaderTableCell>
          <StyledHeaderTableCell>Impressões</StyledHeaderTableCell>
          <StyledHeaderTableCell>Cliques</StyledHeaderTableCell>
          <StyledHeaderTableCell>CTR</StyledHeaderTableCell>
          <StyledHeaderTableCell>CPM</StyledHeaderTableCell>
          <StyledHeaderTableCell>CPC</StyledHeaderTableCell>
          <StyledHeaderTableCell>Investimento</StyledHeaderTableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {isLoading && (
          <TableRow>
            <TableCell component="th" scope="row" colSpan={7} align="center">
              <CircularProgress size={15} /> Carregando
            </TableCell>
          </TableRow>
        )}

        {!isLoading && !isError && data?.list?.length === 0 && (
          <TableRow>
            <TableCell colSpan={7} align="center">
              Sem resultados
            </TableCell>
          </TableRow>
        )}

        {isError && (
          <TableRow>
            <TableCell
              sx={{ color: theme => theme.palette.error.light }}
              colSpan={7}
              align="center"
            >
              <Typography>Ocorreu um erro: {error?.name}</Typography>
              <Typography>{error?.message}</Typography>
            </TableCell>
          </TableRow>
        )}

        {!isLoading &&
          !isError &&
          data?.list?.map((resume: CampaignProductDailyReport) => {
            return (
              <SponsoredProductsReportsBannerRow
                key={resume.date}
                resume={resume}
              />
            );
          })}
      </TableBody>
    </StyledTable>
  );
}
